import { gql } from 'graphql-request';

import {
  DeepArchiveRestoreRequestID,
  DeepArchiveRestoreRequestEstimatedReadyAt,
  DeepArchiveRestoreRequestStatus
} from '../deepArchiveRestoreRequestsTypes';

export interface FileAttachmentDeepArchiveRestoreRequest {
  id: DeepArchiveRestoreRequestID;
  estimatedReadyAt: DeepArchiveRestoreRequestEstimatedReadyAt;
  status: DeepArchiveRestoreRequestStatus;
}

export interface FetchFileAttachmentDeepArchiveRestoreRequestsQueryResponse {
  deepArchiveRestoreRequests: {
    nodes: FileAttachmentDeepArchiveRestoreRequest[];
  };
}

export const FETCH_FILE_ATTACHMENT_DEEP_ARCHIVE_RESTORE_REQUESTS_QUERY = gql`
  query FileAttachmentDeepArchiveRestoreRequests(
    $offset: Int
    $limit: Int
    $filters: DeepArchiveRestoreRequestsFilters
    $sort: [DeepArchiveRestoreRequestsSortEnum!]
  ) {
    deepArchiveRestoreRequests(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
    ) {
      nodes {
        id
        estimatedReadyAt
        status
      }
    }
  }
`;
